import React from 'react';

import { MethodChip } from './styles';

type PaymentMethodChipProps = {
  tone: 'success' | 'primary';
  label: string;
};

export const PaymentMethodChip = (props: PaymentMethodChipProps) => {
  const { tone, label } = props;

  return <MethodChip data-testid='payment-method-chip' data-tone={tone} label={label} size='small' />;
};

export default PaymentMethodChip;
